import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import {
  UPDATE_PORTFOLIO,
  UPDATE_PORTFOLIOS,
  LOAD_PORTFOLIO,
  INITIALIZE_PORTFOLIO,
  GENERATE_DEPOSIT_ADDRESS,
  FETCH_ALL_DEPOSIT_ADDRESSES,
  LOAD_DEPOSIT_HISTORY,
  LOAD_WITHDRAWAL_HISTORY,
  GET_WALLET_TOTAL,
  SET_WITHDRAWAL_LIMIT,
  LOAD_DERIVATIVES_PORTFOLIO,
} from 'redux/actions/portfolio';
import { USER_LOGOUT_STARTED } from 'redux/actions/profile';

const initialState = {
  isLoading: true,
  portfolios: {},
  portfoliosIsLoading: true,
  portfoliosIsLoaded: false,
  addresses: undefined,
  depositHistory: [],
  depositHistoryIsLoading: false,
  walletTotals: {
    btcTotal: undefined,
    fiatTotal: undefined,
  },
  walletTotalsIsLoading: false,
  walletTotalsIsLoaded: false,
  withdrawalHistory: [],
  withdrawalHistoryIsLoading: false,
  isGeneratingAddress: false,
  withdrawalLimit: {},
  derivativesPortfolios: [],
  derivativesPortfoliosIsLoading: false,
};

export const initialPortfolioReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PORTFOLIO.STARTED:
      return { ...state, portfoliosIsLoading: true };
    case INITIALIZE_PORTFOLIO:
      return { ...state, portfoliosIsLoading: false, portfoliosIsLoaded: true, portfolios: action.payload };
    case UPDATE_PORTFOLIOS:
      return { ...state, portfolios: action.payload }; // portfoliosIsLoading: false,
    case UPDATE_PORTFOLIO:
      return {
        ...state,
        portfoliosIsLoading: false,
        portfolios: {
          ...state.portfolios,
          [action.payload.currency]: action.payload,
        },
      };
    case LOAD_PORTFOLIO.SUCCESS:
      return { ...state, portfoliosIsLoading: false, portfolios: action.payload };
    case LOAD_PORTFOLIO.FAIL:
      return { ...state, portfoliosIsLoading: false };

    case FETCH_ALL_DEPOSIT_ADDRESSES.STARTED:
    case LOAD_DERIVATIVES_PORTFOLIO.STARTED:
      return { ...state, isLoading: true };
    case GENERATE_DEPOSIT_ADDRESS.STARTED:
      return { ...state, isLoading: true, isGeneratingAddress: true };

    case LOAD_DERIVATIVES_PORTFOLIO.SUCCESS:
      return {
        ...state,
        isLoading: false,
        derivativesPortfolios: action.payload,
      };

    case FETCH_ALL_DEPOSIT_ADDRESSES.SUCCESS:
      return {
        ...state,
        isLoading: false,
        addresses: {
          ...state.addresses,
          ...action.payload,
        },
      };
    case GENERATE_DEPOSIT_ADDRESS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isGeneratingAddress: false,
        addresses: {
          ...state.addresses,
          [action.payload.currency]: action.payload.address,
        },
      };
    case FETCH_ALL_DEPOSIT_ADDRESSES.FAIL:
    case LOAD_DERIVATIVES_PORTFOLIO.FAIL:
      return { ...state, isLoading: false };
    case GENERATE_DEPOSIT_ADDRESS.FAIL:
      return { ...state, isLoading: false, isGeneratingAddress: false };

    case GET_WALLET_TOTAL.STARTED:
      return { ...state, walletTotalsIsLoading: true };
    case GET_WALLET_TOTAL.SUCCESS:
      return {
        ...state,
        walletTotalsIsLoading: false,
        walletTotalsIsLoaded: true,
        walletTotals: {
          btcTotal: action.payload.btcTotal,
          fiatTotal: action.payload.fiatTotal,
        },
      };
    case GET_WALLET_TOTAL.FAIL:
      return { ...state, walletTotalsIsLoading: false };

    case LOAD_DEPOSIT_HISTORY.STARTED:
      return { ...state, depositHistoryIsLoading: true };
    case LOAD_DEPOSIT_HISTORY.SUCCESS:
      return { ...state, depositHistory: action.payload, depositHistoryIsLoading: false };
    case LOAD_DEPOSIT_HISTORY.FAIL:
      return { ...state, depositHistoryIsLoading: false };

    case LOAD_WITHDRAWAL_HISTORY.STARTED:
      return { ...state, withdrawalHistoryIsLoading: true };
    case LOAD_WITHDRAWAL_HISTORY.SUCCESS:
      return { ...state, withdrawalHistory: action.payload, withdrawalHistoryIsLoading: false };
    case LOAD_WITHDRAWAL_HISTORY.FAIL:
      return { ...state, withdrawalHistoryIsLoading: false };

    case SET_WITHDRAWAL_LIMIT: {
      return { ...state, withdrawalLimit: action.payload };
    }
    case USER_LOGOUT_STARTED: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

const persistConfig = {
  key: 'portfolio',
  storage: storage,
  whitelist: [],
};

export const portfolioReducer = persistReducer(persistConfig, initialPortfolioReducer);
